import { createTranslationService } from '@services/factories';
import { ITranslationService } from '@services/TranslationService';
import { cacheTranslations } from '@utils/cache-translations';
import * as React from 'react';
import CompoundTranslation from '@components/compound-translation';

export enum CitizenshipStatusTranslation {
    citizen = 'citizen',
    nonCitizenNational = 'nonCitizenNational',
    lawfulPermanentResident = 'lawfulPermanentResident',
    authorizedAlien = 'authorizedAlien'
}

// todo: could be moved to configs
export const citizenshipStatusToTranslation = {
    '1': CitizenshipStatusTranslation.citizen,
    '2': CitizenshipStatusTranslation.nonCitizenNational,
    '3': CitizenshipStatusTranslation.lawfulPermanentResident,
    '4': CitizenshipStatusTranslation.authorizedAlien
};

export const getCitizenshipStatusTranslations = (translationsService: ITranslationService) => (
    cacheTranslations(
        translationsService,
        citizenshipStatusToTranslation,
        'citizenShipStatuses'
    )
);

export const getCitizenshipStatusLabel = (
    citizenshipStatus: string | undefined,
    labels: ReturnType<typeof cacheTranslations>
): string | null => {
    try {
        if (!citizenshipStatus) {
            return null;
        }

        const label = labels?.[citizenshipStatus];
        if (!label) {
            return null;
        }

        return label;
    } catch (err) {
        return null;
    }
};

interface Props {
    status?: string;
    fallbackLabel: string;
    /**
     * Template to interpolate the citizenship status with.
     * Interpolation data consists of: [status, statusLabel].
     * Defaults to "{1}" - Showing Status Label
     */
    template?: string;
}

class CitizenshipStatus extends React.Component<Props> {
    readonly translations = getCitizenshipStatusTranslations(createTranslationService());

    render(): React.ReactNode {
        const {
            fallbackLabel,
            status,
            template = '{1}'
        } = this.props;

        if (!status) {
            return fallbackLabel;
        }

        const statusLabel = getCitizenshipStatusLabel(status, this.translations);
        if (!statusLabel) {
            return fallbackLabel;
        }

        return (
            <CompoundTranslation template={template}
                                 data={[status, statusLabel]} />
        );
    }
}

export default CitizenshipStatus;



// WEBPACK FOOTER //
// ./src/screens/review-section3/review/citizenship-status.tsx